import { hydrate } from "preact";
  import Page from "./app/pages/blog/260810.mdx";
  import App from "./app/components/App.tsx";
  import {components} from "./app/components/Components.tsx";
  const vars = globalThis._vars;
  hydrate(<App vars={vars}><Page components={components} {...vars}/></App>, document.getElementById("root")!);